import { getReaderApiBaseUrl } from "@/lib/apiBase";
import type { CharacterVoiceAssignmentApiItem } from "@/lib/mergeServerCharacterVoices";

export type CharacterVoiceUpsertBody = {
  story_id: string;
  character_id: string;
  voice_id: string;
  notes?: string;
};

export type CharacterVoicesListResponse = {
  items: CharacterVoiceAssignmentApiItem[];
};

export async function fetchCharacterVoices(storyId: string): Promise<CharacterVoicesListResponse> {
  const base = getReaderApiBaseUrl();
  const sp = new URLSearchParams({ story_id: storyId });
  const res = await fetch(`${base}/api/character-voices?${sp.toString()}`);
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || `HTTP ${res.status}`);
  }
  return (await res.json()) as CharacterVoicesListResponse;
}

export async function postCharacterVoice(body: CharacterVoiceUpsertBody): Promise<void> {
  const base = getReaderApiBaseUrl();
  const res = await fetch(`${base}/api/character-voices`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      story_id: body.story_id,
      character_id: body.character_id,
      voice_id: body.voice_id,
      notes: body.notes,
    }),
  });
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || `HTTP ${res.status}`);
  }
}
